<template>
  <div>
    <template v-if="windowResize.width < 1024">
      <Camera class="mb-3" :openWindow="openWindow" />
      <FilePicker />
    </template>
    <template v-else>
      <FilePickerDesktop :openWindow="openWindow" />
    </template>
  </div>
</template>

<script>
import { useWindowResize } from '@sichern/ui-elements'
import Camera from './Camera'
import FilePicker from './FilePicker'
import FilePickerDesktop from './FilePickerDesktop'

export default {
  inject: ['state', 'mutations'],
  components: {
    Camera,
    FilePicker,
    FilePickerDesktop
  },
  props: ['openWindow'],
  data() {
    return {
      windowResize: useWindowResize(this)
    }
  }
}
</script>